import { useCallback, useEffect, useRef } from 'react';

export type KeyboardMappings = Record<string, (event?: KeyboardEvent) => void>;

// Generic keyboard effects hook.
// Views register a map of KeyboardEvent.code -> handler while mounted.
// Uses capture phase so handlers can preventDefault before the focused element acts.
export function useKeyboardEffects() {
	const keyboardEventsRef = useRef<KeyboardMappings>({});

	const setKeyboardMappings = useCallback((mappings: KeyboardMappings | null) => {
		keyboardEventsRef.current = mappings ?? {};
	}, []);

	const onKeyDown = useCallback((event: KeyboardEvent) => {
		const handler = keyboardEventsRef.current[event.code];
		if (typeof handler === 'function') {
			handler(event);
		}
	}, []);

	useEffect(() => {
		window.addEventListener('keydown', onKeyDown, true);
		return () => {
			window.removeEventListener('keydown', onKeyDown, true);
		};
	}, [onKeyDown]);

	return setKeyboardMappings;
}

export default useKeyboardEffects;

